import React from "react";
import { InquiryContainer, InquiryText, SideBarButton } from "./styles";
import SparkleIcon from "@/components/SpeakerEmotionBadge/SparkleIcon";
import { designTokens } from "@/styles/designTokens";
import { ReactComponent as ContactIcon } from "@/assets/sidebar/contact.svg?react";
import { useNavigate } from "react-router-dom";

interface InquiryProps {
  isCollapsed: boolean;
}

export const Inquiry: React.FC<InquiryProps> = ({ isCollapsed }) => {
  const navigate = useNavigate();
  const handleInquiryClick = () => {
    navigate("/contact");
  };

  return isCollapsed ? (
    <SideBarButton onClick={handleInquiryClick} $isCollapsed={isCollapsed}>
      <ContactIcon />
      <span>문의하기</span>
    </SideBarButton>
  ) : (
    <InquiryContainer onClick={handleInquiryClick}>
      <SparkleIcon color={designTokens.colors.font.septenary} />
      <InquiryText>
        무엇이든 궁금하다면
        <br />
        지금 문의하세요.
      </InquiryText>
    </InquiryContainer>
  );
};
